export enum ProductionKey {
  AZEITE = 'azeite',
  OLEO = 'oleo',
  FLOCOS = 'flocos',
}

export function getProductionKeyLabel({
  key,
  isTitle,
  unit,
}: {
  key: ProductionKey;
  isTitle?: boolean;
  unit?: boolean;
}) {
  if (unit) {
    switch (key) {
      case ProductionKey.AZEITE:
        return 'litros';
      case ProductionKey.OLEO:
        return 'litros';
      case ProductionKey.FLOCOS:
        return 'Kg';
    }
  }

  switch (key) {
    case ProductionKey.AZEITE:
      return isTitle ? 'Azeite' : 'azeite';
    case ProductionKey.OLEO:
      return isTitle ? 'Óleo' : 'óleo';
    case ProductionKey.FLOCOS:
      return isTitle ? 'Flocos' : 'flocos';
  }
}
